import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackJourneyEvent } from "@/lib/analytics";
import { initVisitorTracking, isNewSession, captureSourceNeighborhood } from "@/lib/visitorTracking";

/** Fires a page_view journey event on every route change, plus session_start once per session. */
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initVisitorTracking();
    captureSourceNeighborhood(location.pathname, location.search);
    if (isNewSession()) {
      trackJourneyEvent("session_start", { entry_path: location.pathname });
    }
    // Small delay so document.title has updated for the new route.
    const t = setTimeout(() => {
      trackJourneyEvent("page_view", {
        path: location.pathname,
        search: location.search || null,
      });
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
};

export default RouteTracker;